import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { ValidationMessages } from '../../misc';
import { InputWithSource } from '../../componentTypes';
import { useContractActions } from '../../context/ContractActionContext';
import { Actions } from '../../stores/ActionStore';
import { useBaseCompanySubscription } from '../../hooks';


const BrokerInput: InputWithSource = ({ input }) => {
    const contractActions = useContractActions();

    useBaseCompanySubscription(input);

    return (
        <GenericSelect
            label={input.name}
            input={input}
            message={ValidationMessages.requiredInput(input.name)}
            onChange={() => contractActions.dispatch(Actions.RebuildNodes)}
        />
    );
};

BrokerInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(BrokerInput);
